import React, { useState, useEffect, useCallback } from 'react';
import { AlertTriangle } from 'react-feather';
import { useLocation } from 'react-router-dom';
import API_BASE_URL from '../../Config/api';
import connectGoogleDrive from './connectGoogleDrive';

const GoogleAuthBanner = () => {
  const [show, setShow] = useState(false);
  const [checking, setChecking] = useState(false);
  const location = useLocation();

  const isCustomer = (localStorage.getItem('userRole') || '').toLowerCase() === 'customer';

  const checkAuthStatus = useCallback(async () => {
    if (checking || isCustomer) return; // Google Drive is an admin-only concern
    setChecking(true);
    try {
      const response = await fetch(`${API_BASE_URL}/api/oauth/status`);
      const data = await response.json();
      setShow(!data.authenticated);
    } catch (error) {
      console.error('Error checking Google auth status:', error);
      setShow(false);
    } finally {
      setChecking(false);
    }
  }, []);

  // Check on mount and on every route change
  useEffect(() => {
    checkAuthStatus();
  }, [location.pathname]);

  // Also check periodically (every 5 minutes)
  useEffect(() => {
    const interval = setInterval(checkAuthStatus, 5 * 60 * 1000);
    return () => clearInterval(interval);
  }, []);

  const handleAuth = async () => {
    const popup = await connectGoogleDrive('Google Auth', 'width=600,height=700,scrollbars=yes');
    if (!popup) return;

    // Poll for auth completion
    const pollTimer = setInterval(async () => {
      try {
        if (popup && popup.closed) {
          clearInterval(pollTimer);
          checkAuthStatus();
          return;
        }
        const response = await fetch(`${API_BASE_URL}/api/oauth/status`);
        const data = await response.json();
        if (data.authenticated) {
          clearInterval(pollTimer);
          if (popup) popup.close();
          setShow(false);
        }
      } catch (e) {
        // ignore polling errors
      }
    }, 2000);

    // Stop polling after 5 minutes
    setTimeout(() => clearInterval(pollTimer), 5 * 60 * 1000);
  };

  if (!show) return null;

  return (
    <div style={{
      background: '#fff3cd',
      border: '1px solid #ffc107',
      borderRadius: '4px',
      padding: '10px 20px',
      margin: '0 15px 10px 15px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      zIndex: 1000,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <AlertTriangle size={18} color="#856404" />
        <span style={{ color: '#856404', fontWeight: 500 }}>
          Google Drive authentication has expired. Uploads to Google Drive will fail until you re-authenticate.
        </span>
      </div>
      <button
        onClick={handleAuth}
        style={{
          background: '#4285f4',
          color: '#fff',
          border: 'none',
          borderRadius: '4px',
          padding: '6px 16px',
          cursor: 'pointer',
          fontWeight: 500,
          whiteSpace: 'nowrap',
          fontSize: '13px',
        }}
      >
        Authenticate Google Drive
      </button>
    </div>
  );
};

export default GoogleAuthBanner;
